import React from 'react';
import { Chart, Tooltip, Geom } from 'bizcharts';
import autoHeight from '../autoHeight';
import '../index.less';
class MiniBar extends React.Component {
    render() {
        const { height, forceFit = true, color = '#1890FF', data = [] } = this.props;
        const scale = {
            x: {
                type: 'cat',
            },
            y: {
                min: 0,
            },
        };
        const padding = [36, 5, 30, 5];
        const tooltip = [
            'x*y',
            (x, y) => ({
                name: x,
                value: y,
            }),
        ];
        // for tooltip not to be hide
        const chartHeight = height + 54;
        return (React.createElement("div", { className: "miniChart", style: { height } },
            React.createElement("div", { className: "chartContent" },
                React.createElement(Chart, { scale: scale, height: chartHeight, forceFit: forceFit, data: data, padding: padding },
                    React.createElement(Tooltip, { showTitle: false, crosshairs: false }),
                    React.createElement(Geom, { type: "interval", position: "x*y", color: color, tooltip: tooltip })))));
    }
}
export default autoHeight()(MiniBar);
